import {MultiSelectComponent} from "./multiselect.component";

export interface IDropdownSettings {
  page?: number;
  size?:number;
  totalpages?:number;
  singleSelection?: boolean;
  singleOutput?: boolean;
  idField?: string;
  textField?: string;
  disabledField?: string;
  enableCheckAll?: boolean;
  selectAllText?: string;
  unSelectAllText?: string;
  allowSearchFilter?: boolean;
  clearSearchFilter?: boolean;
  maxHeight?: number;
  idImage?: string;
  itemsShowLimit?: number;
  limitSelection?: number;
  searchPlaceholderText?: string;
  noDataAvailablePlaceholderText?: string;
  noFilteredDataAvailablePlaceholderText?: string;
  closeDropDownOnSelection?: boolean;
  showSelectedItemsAtTop?: boolean;
  defaultOpen?: boolean;
  allowRemoteDataSearch?: boolean;
  moreButton?: boolean;
  moreButtonText?: string;
  selectIfSingle?: boolean;
  selectFirst?: boolean;
  subtitleField?: string;
  secondSubtitleField?: string;
  excludeIds?: Array<any>;
  allowPagination?: boolean;
  dataLabel?: string;
  campiAggiuntivi?:any[];
  isTreeNav?: boolean;
  HtmlTemplate?: (x:any, component: MultiSelectComponent)=>string;
  HtmlSelectedTemplate?: (x:any, component: MultiSelectComponent)=>string;
  HtmlHead?:(component: MultiSelectComponent)=>string;
}

export class ListItem {
  id: String | number;
  text: String | number;
  isDisabled?: boolean;

  public constructor(source: any) {
    if (typeof source === 'string' || typeof source === 'number') {
      this.id = this.text = source;
      this.isDisabled = false;
    }
    if (typeof source === 'object') {
      this.id = source.id;
      this.text = source.text;
      this.isDisabled = source.isDisabled;
    }
  }
}
